// would be a route open to everyone
import React from "react";
import { Route, withRouter } from "react-router-dom";

const PublicRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      return <Component {...props} />;
    }}
  />
);

export default withRouter(PublicRoute);
